import { AppInstance } from "../../api/instance";

export const ADD_TO_CART = "ADD_TO_CART";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";

const resolveVariantId = (item) =>
  item?.default_variant?.id ?? item?.variant_id ?? item?.id;
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const DELETE_ALL_FROM_CART = "DELETE_ALL_FROM_CART";
export const GET_CART_DATA = "GET_CART_DATA"
export const INCREASE_QUANTITY = "INCREASE_QUANTITY"

//add to cart
export const addToCart = (
  item,
  addToast,
  quantityCount,
  onSuccess,
) => {
  return dispatch => {
    // Make API call first
    AppInstance({
      method: 'post',
      url: '/cart',
      data: {
        variant_id: resolveVariantId(item),
        quantity: quantityCount ? quantityCount : 1,
      }
    }).then((res) => {
      if (res.data.success) {
        // Show success toast only when API call succeeds
        if (addToast) {
          addToast("Added To Cart", {
            appearance: "success",
            autoDismiss: true
          });
        }
        // Dispatch to update state only after API success
        dispatch({
          type: ADD_TO_CART,
          payload: res.data.data
        });
        if (typeof onSuccess === "function") {
          queueMicrotask(() => onSuccess(res.data.data));
        }
      } else {
        // Show error toast if API call fails
        if (addToast) {
          addToast("Failed to add item to cart", {
            appearance: "error",
            autoDismiss: true
          });
        }
      }
    }).catch((error) => {
      console.log(error, "cart add fail");
    });
  };
};
export const getCartData = (userInfo) => {
  return async (dispatch) => {
    if (!userInfo) {
      return
    }
    try {
      const { data } = await AppInstance.get('/cart', {
        headers: {
          Authorization: `Bearer ${userInfo.token}`
        }
      });
      const cartItems = data.data.map((item) => ({
        variant: item.variant,
        quantity: item?.quantity,
        cart_id: item?.cart_id,
        variant_id: item.variant_id ?? item.variant?.id,
        id: item.id // cart line id from API (unique per line)
      }));

      dispatch({
        type: GET_CART_DATA,
        payload: cartItems
      });

    } catch (error) {
      console.log(error);
    }
  };
}

export const decreaseQuantity = (item, addToast) => {
  return dispatch => {
    AppInstance({
      method: 'delete',
      url: `/cart?variant_id=${item.variant_id}&quantity=1`,
    }).then((res) => {
      if (res?.data?.data) {
        dispatch({ type: DECREASE_QUANTITY, payload: res?.data?.data });
      } else if (item?.quantity === 1 || res?.data?.message === "Item does not exist") {
        dispatch({ type: DELETE_FROM_CART, payload: item });
      }
    }).catch((error) => {
      console.log(error, "cart add fail");
    })

  };
};
export const increaseQuantity = (item, addToast, quantity) => {
  return dispatch => {
    AppInstance({
      method: 'post',
      url: '/cart',
      data: {
        variant_id: item.variant_id,
        quantity: quantity ? quantity : 1,
      }
    }).then((res) => {
      if (res.data.success) {
        dispatch({
          type: ADD_TO_CART,
          payload: res.data.data
        });
      } else {
        // Show error toast if API call fails
        if (addToast) {
          addToast("Failed to add item to cart", {
            appearance: "error",
            autoDismiss: true
          });
        }
      }
    }).catch((error) => {
      console.log(error, "cart add fail");
    });
  };
};
//delete from cart
export const deleteFromCart = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Removed From Cart", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: DELETE_FROM_CART, payload: item });
  };
};
//delete all from cart
export const deleteAllFromCart = addToast => {
  return dispatch => {
    if (addToast) {
      addToast("Removed All From Cart", {
        appearance: "error",
        autoDismiss: true
      });
    }
    dispatch({ type: DELETE_ALL_FROM_CART });
  };
};

// get stock of cart item
export const cartItemStock = (item, color, size) => {
  if (item.stock) {
    return item.stock;
  } else {
    return item.variation
      .filter(single => single?.color === color)[0]
      .size.filter(single => single?.name === size)[0].stock;
  }
};
